import { Typography } from "@mui/material";

export default function Header() {
  return (
    <Typography variant="h5" align="center">
      Rock Paper Scissors
    </Typography>
  );
}
